export default "__VITE_ASSET__BeFLx0Nt__"